export default __webpack_public_path__ + "static/media/icon-users.d0403d01.svg";